export const footer = {
  pt: {
    titulofooter: "Projeto Concil-IA",
    copyright: "© 2025 Projeto Concil-IA",
    feedback: "Avalie a nossa ferramenta",
    here: "aqui"
  },
  en: {
    titulofooter: "Projeto Concil-IA",
    copyright: "© 2025 Projeto Concil-IA",
    feedback: "Share your feedback",
    here: "here"
  },
};